module.exports = __webpack_public_path__ + "media/images/email-a214fcb8e383d064dbe0da5a04c321b0.png";